import { render, staticRenderFns } from "./dadosCestaMercado.vue?vue&type=template&id=6674f86d"
import script from "./dadosCestaMercado.vue?vue&type=script&lang=js"
export * from "./dadosCestaMercado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports